<template>
  <section class="c parking-lot-list">
    <template v-if="data !== '__not_loaded__' && data !== undefined">
      <!-- <v-progress-linear :indeterminate="true" v-show="loading"></v-progress-linear> -->
      <empty-state v-show="data.length === 0 && !loading">
        <span v-if="data.length === 0">Kein Parkplatz verfügbar.</span>
      </empty-state>
      <v-list :two-line="twoLine">
        <v-list-tile
          v-for="(item, index) in data"
          :class="`
            ${item.className ? item.className : ''}
            ${showElement(item) ? ' ' : ' is-not-in-map'} ${itemClassName}
            ${highlightId === item.id ? ' is-highlighted' : ''}`"
          :key="item.id"
          :id="`id-${item.id}`"
          avatar
          @mouseover="onItemHover(item.id)"
          @mouseleave="onItemHover(null)"
          @click="onItemClick(item)"
          :ref="`list-item-${item.id}`"
          :to="getLink(item.id)"
          ripple
        >
          <v-list-tile-avatar>
            <number-avatar
              v-if="showIndex"
              :style="`background-color: ${item.backgroundColor}; color: ${item.textColor}`"
            >
              <span v-if="item.visualIndex">{{ item.visualIndex }}</span>
              <span v-else>{{ index + 1 }}</span>
            </number-avatar>
            <v-icon v-else>{{ item.icon }}</v-icon>
          </v-list-tile-avatar>

          <v-list-tile-content>
            <v-list-tile-title>{{ item.name }}</v-list-tile-title>
            <v-list-tile-sub-title
              v-if="twoLine && parkingLotList"
            >
              {{ `${item.parkingSpaceOccupied}/${item.parkingSpaceNumber}` }} Parkplätzen belegt
            </v-list-tile-sub-title>
            <v-list-tile-sub-title
              v-if="twoLine && !parkingLotList"
            >
              {{ item.subtitle }}
            </v-list-tile-sub-title>
          </v-list-tile-content>

          <v-list-tile-action>
            <div v-for="icon in item.trailingIcons" :key="icon.name" class="item-icon">
              <v-tooltip bottom v-if="icon.tooltipMsg">
                <v-icon slot="activator" :color="icon.color">{{ icon.name }}</v-icon>
                <span>{{ icon.tooltipMsg }}</span>
              </v-tooltip>
              <v-icon :color="icon.color" v-else>{{ icon.name }}</v-icon>
            </div>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
    </template>
  </section>
</template>

<script>
import NumberAvatar from '../../basic-components/NumberAvatar.vue';
import EmptyState from '../../basic-components/EmptyState.vue';

export default {
  name: 'parking-lot-list',

  components: {
    NumberAvatar,
    EmptyState,
  },

  props: {
    data: {
      required: true,
    },
    twoLine: {
      type: Boolean,
      default: false,
    },
    showIndex: {
      type: Boolean,
      default: false,
    },
    itemClassName: {
      type: String,
      default: '',
    },
    highlightId: {
      type: String,
      default: null,
    },
    highlightColor: {
      type: String,
    },
    showIds: {
      type: Array,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    link: {
      type: [String, Boolean],
      default: 'parking_lot',
    },
    parkingLotList: {
      type: Boolean,
      default: true,
    },
  },

  watch: {
    highlightColor() {
      this.$el.querySelector(`#id-${this.highlightId}`).style = `border: solid 4px ${this.highlightColor};`;
    },
  },

  methods: {
    onItemClick(args) {
      this.$emit('item-click', args);
    },
    onItemHover(args) {
      this.$emit('item-hover', args);
    },
    showElement(item) {
      if (this.showIds !== null) {
        if (this.showIds.indexOf(item.id) !== -1) {
          return true;
        }
        if (!item.shape) {
          this.showIds.push(item.id);
          return true;
        }
        return false;
      }
      return true;
    },
    getLink(id) {
      if (this.link) {
        return `/${this.link}/${id}`;
      }
      return undefined;
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.$emit('load');
    });
  },
};
</script>
